// @vendors
const React = require("react");
const { FormattedText, formatText } = require("core/i18n").i18n;
const PropTypes = require('prop-types');

// @components
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const BrokerDataItem = require("components/commons/brokerDataItem/brokerDataItem");
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @images
const privateIcon = require("assets/images/info-icon.svg");
const ccIcon = require('assets/images/icon-tutorial.svg');

// helpers
const {
    formatCurrency,
    formatWithoutRound,
    formatPercentage,
    formatAmount,
} = require("utilities/currencyHelper");
const IbanHelper = require('utilities/ibanHelper');
const { toFirstUppercase } = require('utilities/stringHelper');


// @constants
const { BROKER_REIMBURSE_FUND_TOTAL, EURO_TEXT } = require('constants/index');
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER, FIRST_STEP,
    BROKER_FUNDS_INTERNAL_TRANSFER_CONTRACT_FORMAT,
    BROKER_INTERNAL_TRANSFER_EXISTING_FUND,
    BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_AMOUNT,
    BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS,
    BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PERCENTAGE,
    POTENTIAL_COST_TYPE,
    POTENTIAL_SELL_FUNDS_COSTS,
    POTENTIAL_COST
} = require('constants/index');
class BrokerInternalTransferFundsStep2ExantDetails extends React.Component {


    buildRightPart() {
        const { immBrokerInternalTransferFunds } = this.props;

        return immBrokerInternalTransferFunds.get('exAnteCostList').map((item, index) => (
            item.get('type')  !== POTENTIAL_COST &&
            (
            <BrokerExAntSection
                context="brokerInternalTransferFund"
                eventCategory="traspaso entre fondos/paso 2"
                section={item}
                key={index}
                complexTooltip={true}
              />
            )
        ));
    }

    buildCostInfo(potentialSellTransferFundsCostsText) {
        const { immBrokerInternalTransferFunds } = this.props;
        const periodicityLabel = immBrokerInternalTransferFunds.getIn(['steps', 1, 'periodicityLabel']);
        const estimatedContributionCost = immBrokerInternalTransferFunds.getIn(['recurringTransferCosts', 'total', 'amount' ]);
        const contributionCurrency = formatCurrency(immBrokerInternalTransferFunds.getIn(['steps', 1, 'currencyCode']), EURO_TEXT);
        const isContributionStepSkipped = immBrokerInternalTransferFunds.get('skipContributionStep');

        if (periodicityLabel && !isContributionStepSkipped) {
            return (
                <div className="broker-internal-transfer-funds-step2__info-costs">
                    <div>
                        <FormattedText value="brokerInternalTransferFund-ExantCost_contributionInfoCost" injectedStrings={[periodicityLabel]} />
                        {` ${estimatedContributionCost} ${contributionCurrency}.`}
                    </div>
                    {potentialSellTransferFundsCostsText}
                    <div className="broker-ex-ant-cost__section-total-separator" />
                    <div>
                        <FormattedText value="brokerInternalTransferFund-ExantCost_potencialCostsExplanation" />
                    </div>
                </div>
            );
        } else return <div>{potentialSellTransferFundsCostsText}</div>
    }

    formatParticipationsAmount(raw) {
        const fraction = `${raw}`.split('.')[1];
        const fractionLength = fraction ? fraction.length : 0;

        return formatAmount(raw, null, fractionLength);
    }

    generateFundDetails(fund) {
        const { immBrokerMyInvestments, immBrokerInternalTransferFunds, immFunds } = this.props;
        const fundId  = immBrokerInternalTransferFunds.getIn(['steps', 0, fund]);
        const funds = immBrokerMyInvestments.getIn(['products','funds','stocks']);
        const selectedFund = funds.find(fund => fund.get('id') === fundId);
        if(selectedFund) {
            const fundDetails = immFunds.find(fund =>
                selectedFund &&
                fund.getIn(['contrato','producto']) === selectedFund.get('product') &&
                fund.getIn(['contrato','numerodecontrato']) === selectedFund.get('numerodecontrato')
            );
            if(fundDetails) {
                return fundDetails.merge({
                    controlDigit: selectedFund.get('controlDigit')
                });
            }
        }
    }

    buildContent() {
        const {
            immAccounts,
            immBrokerInternalTransferFunds,
        } = this.props;
        const isTotal =
            immBrokerInternalTransferFunds.getIn(["steps", 0, "type"]) ===
            BROKER_REIMBURSE_FUND_TOTAL;
        const partialType = immBrokerInternalTransferFunds.getIn([
            "steps",
            FIRST_STEP,
            "partialType",
        ]);
        const selectedOriginFund = this.generateFundDetails('originFund');

        let originFundName,
            originAccountCurrency,
            originAccountDetails,
            originEstimatedValue,
            originFundCustody,
            originFundOwner;
        if (selectedOriginFund) {
            const originAccountProduct = selectedOriginFund.getIn(['cuentaAsociada', 'subgrupo'], '');
            const originAccountContract = selectedOriginFund.getIn(['cuentaAsociada', 'numerodecontrato'], '');
            const immOriginAccount = immAccounts.get('byId').find(account =>
                account.get('product') === originAccountProduct && account.get('contractNumber') === originAccountContract
            );

            let originAccountControlDigit, originAccountBalance;
            if (immOriginAccount) {
                const originAccountAmount = formatWithoutRound(
                    immOriginAccount.getIn(
                        ["balances", "realBalance", "amount"],
                        0
                    ),
                    2
                );
                originAccountCurrency = formatCurrency(
                    immOriginAccount.getIn(
                        ["balances", "realBalance", "currency"],
                        EURO_TEXT
                    )
                );
                originAccountControlDigit = immOriginAccount.getIn(
                    ["ibanComplex", "digitodecontrol"],
                    ""
                );
                originAccountBalance = `${originAccountAmount} ${originAccountCurrency}`
            }
            const originAccountNumber = IbanHelper.formatAccountTextWithSpaces(
                `${API_ENTERPRISE_NUMBER}${API_CENTER}${originAccountControlDigit}${originAccountProduct}${originAccountContract}`,
                BROKER_FUNDS_INTERNAL_TRANSFER_CONTRACT_FORMAT
            );

            const originAccountAlias = immOriginAccount.get('description', '').trim();

            originAccountDetails = formatText(
                "brokerInternalTransferFund-ExantCost_OrderDataAccountDetails",
                [originAccountAlias, originAccountNumber, originAccountBalance]
            );

            originFundName = selectedOriginFund.get('descripcion', '');

            const estimatedBaseAmountObject = immBrokerInternalTransferFunds.get('estimatedBaseAmount');
            const estimatedBaseAmountExchangedObject = immBrokerInternalTransferFunds.get('estimatedBaseAmountExchanged');

            const estimatedBaseAmountBalance = !!estimatedBaseAmountObject
                ? formatWithoutRound(
                    estimatedBaseAmountObject.get("amount", 0),
                    2
                )
                : 0;
            const estimatedBaseAmountCurrency = !!estimatedBaseAmountObject
                ? formatCurrency(
                    estimatedBaseAmountObject.get("currency", "EUR")
                )
                : formatCurrency("EUR");

            if (!!estimatedBaseAmountExchangedObject) {
                const estimatedBaseAmountExchangedBalance =
                    !!estimatedBaseAmountExchangedObject
                        ? formatWithoutRound(
                            estimatedBaseAmountExchangedObject.get(
                                "amount",
                                0
                            ),
                            2
                        )
                        : 0;
                const estimatedBaseAmountExchangedCurrency =
                    !!estimatedBaseAmountExchangedObject
                        ? formatCurrency(
                            estimatedBaseAmountExchangedObject.get(
                                "currency",
                                "EUR"
                            )
                        )
                        : formatCurrency("EUR");

                    originEstimatedValue = `${estimatedBaseAmountBalance} ${estimatedBaseAmountCurrency} | ${estimatedBaseAmountExchangedBalance} ${estimatedBaseAmountExchangedCurrency}`;
            }else {
                originEstimatedValue = `${estimatedBaseAmountBalance} ${estimatedBaseAmountCurrency}`
            }
            const originFundControlDigit = selectedOriginFund.get('controlDigit', '');
            const originProductValue = selectedOriginFund.getIn(['contrato', 'producto'], '');
            const originContractNumberValue = selectedOriginFund.getIn(['contrato', 'numerodecontrato'], '');
            originFundCustody = IbanHelper.formatAccountTextWithSpaces(
                `${API_ENTERPRISE_NUMBER}${API_CENTER}${originFundControlDigit}${originProductValue}${originContractNumberValue}`,
                BROKER_FUNDS_INTERNAL_TRANSFER_CONTRACT_FORMAT
            );

            originFundOwner = selectedOriginFund.get('nombretitular', '');

        }

        const selectedDestinationFund = this.generateFundDetails('destinationFund');

        const destinationFundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);
        let destinationFundName,
            destinationFundCustody,
            destinationFundOwner,
            destinationAccountDetails;
        if (destinationFundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND){
            destinationFundName = selectedDestinationFund.get('descripcion', '');
            const originFundControlDigit = selectedDestinationFund.get('controlDigit', '');
            const originProductValue = selectedDestinationFund.getIn(['contrato', 'producto'], '');
            const originContractNumberValue = selectedDestinationFund.getIn(['contrato', 'numerodecontrato'], '');
            destinationFundCustody = IbanHelper.formatAccountTextWithSpaces(
                `${API_ENTERPRISE_NUMBER}${API_CENTER}${originFundControlDigit}${originProductValue}${originContractNumberValue}`,
                BROKER_FUNDS_INTERNAL_TRANSFER_CONTRACT_FORMAT
            );

            destinationFundOwner = selectedDestinationFund.get('nombretitular', '');

            const destinationAccountProduct = selectedDestinationFund.getIn(['cuentaAsociada', 'subgrupo'], '');
            const destinationAccountContract = selectedDestinationFund.getIn(['cuentaAsociada', 'numerodecontrato'], '');
            const immDestinationAccount = immAccounts.get('byId').find(account =>
                account.get('product') === destinationAccountProduct && account.get('contractNumber') === destinationAccountContract
            );

            let destinationAccountControlDigit, destinationAccountBalance;
            if (immDestinationAccount) {
                const destinationAccountAmount = formatWithoutRound(
                    immDestinationAccount.getIn(
                        ["balances", "realBalance", "amount"],
                        0
                    ),
                    2
                );
                const destinationAccountCurrency = formatCurrency(
                    immDestinationAccount.getIn(
                        ["balances", "realBalance", "currency"],
                        EURO_TEXT
                    )
                );
                destinationAccountControlDigit = immDestinationAccount.getIn(
                    ["ibanComplex", "digitodecontrol"],
                    ""
                );
                destinationAccountBalance = `${destinationAccountAmount} ${destinationAccountCurrency}`
            }
            const destinationAccountNumber = IbanHelper.formatAccountTextWithSpaces(
                `${API_ENTERPRISE_NUMBER}${API_CENTER}${destinationAccountControlDigit}${destinationAccountProduct}${destinationAccountContract}`,
                BROKER_FUNDS_INTERNAL_TRANSFER_CONTRACT_FORMAT
            );

            const destinationAccountAlias = immDestinationAccount.get('description', '').trim();

            destinationAccountDetails = formatText(
                "brokerInternalTransferFund-ExantCost_OrderDataAccountDetails",
                [destinationAccountAlias, destinationAccountNumber, destinationAccountBalance]
            );

        }else {
            destinationFundName = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFundName']);
        }

        let type, operationLabel, operationAmount;
        if (isTotal) {
            type = formatText('brokerInternalTransferDetails-total');
            operationLabel = 'brokerInternalTransferFund-ExantCost_OrderDataSharesLabel';
            operationAmount = this.formatParticipationsAmount(selectedOriginFund.get('participaciones', 0));
        } else {
            type = formatText(
                `brokerInternalTransferDetails-partial${toFirstUppercase(
                    partialType
                )}`
            );

            const value = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, partialType]);
            switch (partialType) {
                case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_AMOUNT:
                    const valueAmount = immBrokerInternalTransferFunds.get('estimatedBaseAmount');
                    const formattedAmount = !!valueAmount
                        ? formatWithoutRound(
                            valueAmount.get("amount", 0),
                            2
                        )
                        : 0;
                    const formattedCurrency = !!valueAmount
                        ? formatCurrency(
                            valueAmount.get("currency", "EUR")
                        )
                        : formatCurrency("EUR");
                    operationLabel = 'brokerInternalTransferFund-ExantCost_OrderDataAmountLabel'
                    operationAmount = `${formattedAmount} ${formattedCurrency}`
                    break;
                case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS:
                    operationLabel = 'brokerInternalTransferFund-ExantCost_OrderDataSharesLabel';
                    operationAmount =  this.formatParticipationsAmount(value);
                    break;
                case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PERCENTAGE:
                    operationLabel = 'brokerInternalTransferFund-ExantCost_OrderDataPercentajeLabel'
                    operationAmount = formatPercentage(value);
                    break;
                default:
                    operationLabel = '';
                    operationAmount = '';
                    break;
            }
        }
        const exAnteData = immBrokerInternalTransferFunds.get("exAnteCostList");

        let potentialSellTransferFundsCostsText;
        if (exAnteData.toJS().length > 0) {

            const potentialSellTransferFundsCosts  = exAnteData.find(
                (item) => item.get("descriptionKey") === POTENTIAL_SELL_FUNDS_COSTS
            );

            if (potentialSellTransferFundsCosts && potentialSellTransferFundsCosts.get('type') === POTENTIAL_COST) {
                const dataPotentialCosts = potentialSellTransferFundsCosts.get('details').toJS()[0];
                const currency = formatCurrency(dataPotentialCosts.currency ? dataPotentialCosts.currency : 'EUR');
                const amount = formatWithoutRound(dataPotentialCosts.amount, 2);
                const immPercentage = formatPercentage(dataPotentialCosts.percentage, 2);
                const formatAmount = `${amount} ${currency}`;
                const tooltipIcon = __CONTACT_CENTER__ ? ccIcon : privateIcon;
                const tooltipTarget = (<img className="broker-ex-ant-cost__item-tooltip" src={tooltipIcon}></img>);
                const tooltip = potentialSellTransferFundsCosts.getIn(['total','tooltipKey']) ? (
                    <OKTooltip
                        title={formatText('brokerInternalTransferFund-exantCost_potentialCostTooltip_title')}
                        content={formatText('brokerInternalTransferFund-exantCost_potentialCostTooltip_content')}
                        placement="top"
                        type={"custom"}
                        target={tooltipTarget}
                        offset={[0, -15]}
                    />
                ) : null;

                const text = formatText('brokerInternalTransferFund-exantCost_potentialCost_footer', [formatAmount, immPercentage])
                const cssForCC = __CONTACT_CENTER__ && "broker-internal-transfer-funds-step2__info-section-cc-potential-cost";
                potentialSellTransferFundsCostsText = (
                    <div className={cssForCC}>
                        {text} {tooltip}
                    </div>
                );
            }
        }
        const contributionAmount = immBrokerInternalTransferFunds.getIn(['steps', 1, 'amount'])
        const contributionPeriodicity = immBrokerInternalTransferFunds.getIn(['steps', 1, 'periodicityLabel'])
        const contributionCurrency = formatCurrency(immBrokerInternalTransferFunds.getIn(['steps', 1, 'currencyCode']), EURO_TEXT);
        const isContributionStepSkipped = immBrokerInternalTransferFunds.get('skipContributionStep');
        const contributionAmountItem = contributionAmount && !isContributionStepSkipped ? (
            <BrokerDataItem
                label="brokerInternalTransferFund-ExantCost_OrderDataContributionAmountLabel"
                data={`${formatAmount(contributionAmount)} ${contributionCurrency} ${contributionPeriodicity}`}
            />
        ) : null;

        return (
            <div className="broker-internal-transfer-funds-step2__info-section">
                <div className="broker-internal-transfer-funds-step2__info-section-left">
                    <div className="broker-internal-transfer-funds-step2__info-section-subtitle">
                        <FormattedText value="brokerInternalTransferFund-ExantCost_OrderDataSubtitle" />
                    </div>
                    <ul className="broker-internal-transfer-funds-step2__info-section-sub-section">
                        <BrokerDataItem
                            label="brokerInternalTransferFund-ExantCost_OrderDataOriginFundLabel"
                            data={originFundName}
                        />
                        <BrokerDataItem
                            label="brokerInternalTransferFund-ExantCost_OrderDataOriginFundEstimatedAmountLabel"
                            tooltipTitleKey="brokerInternalTransferFund-ExantCost_OrderDataOriginFundEstimatedAmountTooltipTitle"
                            tooltipContentKey="brokerInternalTransferFund-ExantCost_OrderDataOriginFundEstimatedAmountComplexTooltipContent"
                            data={originEstimatedValue}
                            eventCategory="traspaso entre fondos/paso 2"
                            eventTag={formatText("brokerInternalTransferFund-orderData_estimatedAmount_eventTag")}
                            complexTooltip
                        />

                        <BrokerDataItem
                            label="brokerInternalTransferFund-ExantCost_OrderDataOriginFundDepositLabel"
                            data={originFundCustody}
                        />

                        <BrokerDataItem
                            label="brokerInternalTransferFund-ExantCost_OrderDataOriginFundOwnerLabel"
                            data={originFundOwner}
                        />

                        <BrokerDataItem
                            label="brokerInternalTransferFund-ExantCost_OrderDataOriginFundAssociatedAccountLabel"
                            data={originAccountDetails}
                        />
                    </ul>
                    <div className="broker-internal-transfer-funds-step2__info-section-destination-fund">
                        <ul className="broker-internal-transfer-funds-step2__info-section-sub-section">
                            <BrokerDataItem
                                label="brokerInternalTransferFund-ExantCost_OrderDataDestinationFundLabel"
                                data={destinationFundName}
                            />
                            { destinationFundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND &&
                                <div>

                                    <BrokerDataItem
                                        label="brokerInternalTransferFund-ExantCost_OrderDataDestinationFundContractLabel"
                                        data={destinationFundCustody}
                                    />

                                    <BrokerDataItem
                                        label="brokerInternalTransferFund-ExantCost_OrderDataDestinationFundOwnerLabel"
                                        data={destinationFundOwner}
                                    />

                                    <BrokerDataItem
                                        label="brokerInternalTransferFund-ExantCost_OrderDataDestinationFundAssociatedAccountLabel"
                                        data={destinationAccountDetails}
                                    />
                                </div>
                            }
                        </ul>
                    </div>
                    <div className="broker-internal-transfer-funds-step2__info-section-transfer-details">
                        <ul className="broker-internal-transfer-funds-step2__info-section-sub-section">
                            <BrokerDataItem
                                label="brokerInternalTransferFund-ExantCost_OrderDataTransferTypeLabel"
                                data={type}
                            />

                            <BrokerDataItem
                                label={operationLabel}
                                data={operationAmount}
                            />
                            {contributionAmountItem}
                        </ul>
                    </div>
                </div>
                <div className="broker-internal-transfer-funds-step2__info-section-right">
                    {this.buildRightPart()}
                    {this.buildCostInfo(potentialSellTransferFundsCostsText)}
                </div>
            </div>
        );
    }

    render() {
        const { immBrokerInternalTransferFunds } = this.props;
        const periodicityLabel = immBrokerInternalTransferFunds.getIn(['steps', 1, 'periodicityLabel']);
        const isContributionStepSkipped = immBrokerInternalTransferFunds.get('skipContributionStep');
        const hasContributionStep = periodicityLabel && !isContributionStepSkipped;
        const exAnteData = immBrokerInternalTransferFunds.get("exAnteCostList");
        const potentialSellCostFunds  = exAnteData && exAnteData.find(
            (item) => item.get("descriptionKey") === "potentialSellFundsCosts"
        );

        if (
            immBrokerInternalTransferFunds.get("exAnteFetching")
        ) {
            return <LoadingSection />;
        }


        const content = __CONTACT_CENTER__ ? (
            <BlockInfo extraClass="broker-internal-transfer-funds-step2__info-section-cc">
                <FormattedText
                    className="broker-internal-transfer-funds-step2__info-section-cc-subtitle"
                    value="brokerInternalTransferFund-confirmationSubtitle"
                />
                {this.buildContent()}
                {potentialSellCostFunds && potentialSellCostFunds.get('type') === POTENTIAL_COST_TYPE &&
                    <FormattedText
                        className="broker-internal-transfer-funds-step2__info-section-cc-footer-text"
                        value="brokerInternalTransferFund-ExantCost_footerText"
                    />
                }
            </BlockInfo>
        ) : (
            <div>
                {this.buildContent()}
                {potentialSellCostFunds && potentialSellCostFunds.get('type') === POTENTIAL_COST_TYPE && !hasContributionStep &&
                    <FormattedText
                        className="broker-internal-transfer-funds-step2__info-section-footer-disclaimer"
                        value="brokerInternalTransferFund-ExantCost_footerTextPrivate"
                    />
                }
            </div>
        );
        return(content);
    }
}

BrokerInternalTransferFundsStep2ExantDetails.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immBrokerInternalTransferFunds: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immFunds: PropTypes.object.isRequired,
};

module.exports = BrokerInternalTransferFundsStep2ExantDetails;
